import { getAuth } from "firebase/auth";
import { API_ENDPOINT, PAYPAL_BASIC_PLAN_ID, PAYPAL_CLIENT_ID, PAYPAL_PLUS_PLAN_ID } from "../constants";
import "../service/FirebaseAndFreedomCRMService"
import PrettyNaoAnalytics from "../service/AnalyticsService";

type PlanType = 'fan' | 'lover' // basic, plus

// Define your plans here
const subscriptionPlans = [
  {
    id: PAYPAL_BASIC_PLAN_ID,
    label: 'Basic Membership Plan',
    type: 'fan',
  },
  {
    id: PAYPAL_PLUS_PLAN_ID,
    label: 'Plus Membership Plan',
    type: 'lover',
  }
];

window.addEventListener('DOMContentLoaded', () => {
  const auth = getAuth();

  const paypalScript = document.createElement('script');
  paypalScript.src = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&vault=true&intent=subscription`;

  paypalScript.onload = () => {
    subscriptionPlans.forEach(({ id, type }) => {
      const containerId = `#paypal-button-container-${type}`;
      const container = document.querySelector(containerId);
      if (!container) {
        console.warn(`PayPal container not found: ${containerId}`);
        return;
      }

      (window as any).paypal.Buttons({
        style: { shape: 'rect', color: 'gold', layout: 'vertical', label: 'subscribe' },

        createSubscription: function(data, actions) {
          return actions.subscription.create({ plan_id: id });
        },

        onApprove: async function(data: unknown) {
          const user = auth.currentUser;

          if (!user) {
            alert("You must be signed in first.");
            return;
          }

          PrettyNaoAnalytics.getPlausible()?.trackEvent('paypal_on_approve')

          const idToken = await user.getIdToken();

          await fetch(`${API_ENDPOINT}/paypal-subscription-map`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${idToken}`,
            },
            body: JSON.stringify({
              subscriptionID: data.subscriptionID,
              planID: id,
            }),
          });
        },

        onError: function(err: Error) {
          console.error(`PayPal Button error for plan ${id}:`, err);
        }
      }).render(containerId);

      //container.classList.add('hidden')
    });
  };

  document.body.appendChild(paypalScript);

  const loginPrompt = document.getElementById('login-prompt');
  const paymentSection = document.getElementById('payment-section');

  async function checkSessionAuth() {
    try {
      const res = await fetch(`${API_ENDPOINT}/validate-session`, {
        method: "GET",
        credentials: "include"
      });

      if (!res.ok) throw new Error("Not authenticated");

      // Authenticated
      loginPrompt?.classList.add("hidden");
      return true
    } catch (err) {
      // Not authenticated
      if (selectedMembershipPlan) {
        loginPrompt?.classList.remove("hidden");
      }
      paymentSection?.classList.add("opacity-0");
      return false
    }
  }

  checkSessionAuth();
  document.addEventListener('signin-complete', () => {
    checkSessionAuth().then(isAuthed => {
      if (isAuthed) {
        showAndScrollToPaymentSection(selectedMembershipPlan)
      }
    })
  })

  const walletData = {
    solana: {
      address: "8uR8kX3Txu2cAzJS9kHQv8LwJYvK5q9Nf7HdK6KYwT7P3",
      qr: "/static/images/wallets/sol.png"
    },
    eth: {
      address: "0xC47d9eFCD6D1F7b20a1EcFfa4508b6148B8c437B",
      qr: "/static/images/wallets/eth.png"
    },
    btc: {
      address: "bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh",
      qr: "/static/images/wallets/btc.png"
    }
  };

  document.getElementById('copy-crypto-address-btn').addEventListener('click', function(event) {
    const addressText = document.getElementById('crypto-address').textContent.split(' ')[0];

    PrettyNaoAnalytics.getPlausible()?.trackEvent('membership_copy_crypto_address', {
      props: {
        address: addressText,
      },
    })

    navigator.clipboard.writeText(addressText)
      .then(() => {
        const btn = event.currentTarget;
        btn.innerText = '✅';
        setTimeout(() => {
          btn.innerText = '📋';
        }, 1500);
      });
  });

  const tokenMap = {
    solana: ['SOL', 'USDC', 'USDT'],
    eth: ['ETH', 'USDC', 'USDT'],
    btc: ['BTC']
  };

  function updateCryptoDisplay() {
    const network = document.getElementById('crypto-network-select').value;
    const { address, qr } = walletData[network];

    document.getElementById('crypto-qr-code').src = qr;
    document.getElementById('crypto-address').textContent = `${address} (${network.toUpperCase()})`;

    // Update token dropdown
    const tokenSelect = document.getElementById('crypto-token-select');
    tokenSelect.innerHTML = '';
    tokenMap[network].forEach(token => {
      const opt = document.createElement('option');
      opt.value = token;
      opt.textContent = token;
      tokenSelect.appendChild(opt);
    });
  }

  updateCryptoDisplay()

  let selectedMembershipPlan: null | PlanType = null;

  document.getElementById('crypto-network-select').addEventListener('change', updateCryptoDisplay);

  function selectMembershipPlan(planKey: string) {
    selectedMembershipPlan = planKey;

    checkSessionAuth().then(isAuthed => {
      if (isAuthed) {
        showAndScrollToPaymentSection(planKey)
      } else {
        document.getElementById('exclusive-modal').showModal()
      }
    })
  }

  function showAndScrollToPaymentSection(planKey: PlanType) {
    if (!planKey) {
      console.warn('missing planKey')
      return
    }

    subscriptionPlans.forEach(({ type, id }) => {
      const paypalButtonContainerId = `paypal-button-container-${id}`;
      const planEl = document.getElementById(paypalButtonContainerId)
      if (type === planKey) {
        planEl?.classList.remove('hidden')
      } else if (!planEl?.classList.contains('hidden')) {
        planEl?.classList.add('hidden')
      }
    })

    // Enable payment section
    const paymentSection = document.getElementById('payment-section');
    paymentSection?.classList.add('animate-fade-in');
    paymentSection?.classList.remove('opacity-0');

    // Visually highlight selected plan
    document.querySelectorAll('[data-plan-card]').forEach(card => {
      card.classList.remove('border-4', 'border-success');
    });
    const selectedCard = document.querySelector(`[data-plan-card="${planKey}"]`);
    selectedCard?.classList.add('border-4', 'border-success');

    // Auto-scroll to checkout section
    const scrollTarget = document.getElementById('payment-section');
    scrollTarget?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.querySelectorAll('.select-plan-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const planKey = btn.dataset.plan;
      selectMembershipPlan(planKey);

    PrettyNaoAnalytics.getPlausible()?.trackEvent('membership_select_plan', {
      props: {
        plan: planKey,
      },
    })
    });
  });

  function showPaymentVerificationModal() {
    document.getElementById('payment-verification-modal')?.showModal();
  }

  document.getElementById('confirm-crypto-payment-btn')?.addEventListener('click', async () => {
    PrettyNaoAnalytics.getPlausible()?.trackEvent('membership_confirm_manual_crypto_payment', {
      props: {
        plan: selectedMembershipPlan?.toString() || '',
      },
    })

    const network = (document.getElementById('crypto-network-select') as HTMLSelectElement).value;
    const token = (document.getElementById('crypto-token-select') as HTMLSelectElement).value;

    const res = await fetch(`${API_ENDPOINT}/payment/notify-manual`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        method: 'crypto',
        network,
        token,
        plan: selectedMembershipPlan,
      })
    });

    if (res.ok) {
      document.getElementById('manual-pay-modal')?.close();
      showPaymentVerificationModal();
    } else {
      alert("❌ There was an issue notifying us. Please email hello@prettynao.com");
    }
  });

  document.getElementById('confirm-yape-payment-btn')?.addEventListener('click', async () => {
    PrettyNaoAnalytics.getPlausible()?.trackEvent('membership_confirm_manual_yape_payment', {
      props: {
        plan: selectedMembershipPlan?.toString() || '',
      },
    })

    const res = await fetch(`${API_ENDPOINT}/payment/notify-manual`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        method: 'yape',
        plan: selectedMembershipPlan,
      })
    });

    if (res.ok) {
      document.getElementById('yape-modal')?.close();
      showPaymentVerificationModal();
    } else {
      alert("❌ There was an issue notifying us. Please email hello@prettynao.com");
    }
  });

  document.getElementById('checkout-yape-btn')?.addEventListener('click', () => {
    PrettyNaoAnalytics.getPlausible()?.trackEvent('membership_click_yape_checkout')
    document.getElementById('yape-modal')?.showModal();
  });

  document.getElementById('checkout-crypto-btn')?.addEventListener('click', () => {
    PrettyNaoAnalytics.getPlausible()?.trackEvent('membership_click_crypto_checkout')
    document.getElementById('manual-pay-modal')?.showModal();
  });

});

